import { ADVANCED_SEARCH_BULK_PASTE_HOW_IT_WORKS_VIDEO_URL } from '@aibees/elephant/constants';
import { MAX_VALUES } from '@aibees/elephant/feature/search-filters/filters/autocomplete-filter/components/advanced-bulk-input-dialog/config';
import { VideoModal } from '@aibees/shared/components';
import { useBoolean } from '@aibees/shared/hooks';
import { classnames } from '@aibees/shared/utils';
import { Alert, AlertTitle } from '@mui/material';
import Gleap from 'gleap';
import { memo } from 'react';
import * as Styled from './styles';
import type { SearchLimitAlertDialogPaidUserMessageProps as Props } from './types';

export const SearchLimitAlertDialogPaidUserMessage = memo(
  ({ className }: Props) => {
    const videoState = useBoolean();

    const handleOpenContact = () => {
      Gleap.open();
    };

    return (
      <Styled.Wrapper
        className={classnames(
          'SearchLimitAlertDialogPaidUserMessage',
          className
        )}
        gap={1.5}
      >
        <Alert severity="warning" icon={false}>
          {/* Single inline child: the themed Alert message is a flex column,
              so multiple children would each land on their own line. */}
          <div style={{ display: 'inline' }}>
            You’ve exceeded the allowed number of actions for this period.
            Access will resume automatically once the limit resets. This
            typically happens when automated tools or scrapers are used. In rare
            cases, fast manual activity can trigger it too. If you’re adding
            several items, our “Advanced Search” lets you add up to {MAX_VALUES}{' '}
            items at once.{' '}
            <Styled.HowItWorksLink onClick={videoState.onTrue}>
              [see how it works]
            </Styled.HowItWorksLink>
          </div>
        </Alert>
        {/* The video is about bulk-pasting items in Advanced Search, not about
            rate limits — the title must say so. */}
        <VideoModal
          state={videoState}
          videoUrl={ADVANCED_SEARCH_BULK_PASTE_HOW_IT_WORKS_VIDEO_URL}
          title="Paste multiple job titles or keywords at once"
        />
        <Alert severity="default" icon={false}>
          <AlertTitle>Important Note</AlertTitle>
          <div style={{ display: 'inline' }}>
            Unusually high activity may trigger an account review to ensure fair
            use. If you believe this is a mistake, please{' '}
            <Styled.ContactLink onClick={handleOpenContact}>
              contact support
            </Styled.ContactLink>
            .
          </div>
        </Alert>
      </Styled.Wrapper>
    );
  }
);

SearchLimitAlertDialogPaidUserMessage.displayName =
  'SearchLimitAlertDialogPaidUserMessage';
